<p-splitButton
  *ngIf="options.length > 0"
  [label]="text"
  [icon]="icon"
  [size]="size"
  [severity]="primeButtonStyle.severity"
  [outlined]="primeButtonStyle.variant === primeVariant.Outlined"
  [text]="primeButtonStyle.variant === primeVariant.Text"
  [dropdownIcon]="dropdownIcon"
  [model]="options"
  (onClick)="handleAction()"
></p-splitButton>

<shared-ui-buttons-button *ngIf="options.length < 1" [icon]="icon" [size]="size" [type]="type" [text]="text" (action)="handleAction()"></shared-ui-buttons-button>
